const Footer = () => {
  return (
    <footer className="bg-[hsl(220_14%_96%)] border-t border-[hsl(220_13%_91%)]">
      <div className="mx-auto max-w-7xl px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[hsl(0_0%_50%)]">
            © {new Date().getFullYear()} GreenLight. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://getgreenlight.net/privacy-policy"
              className="text-sm text-[hsl(0_0%_50%)] hover:text-[hsl(0_0%_5%)] transition-colors"
            >
              Privacy Policy
            </a>
            <span className="text-[hsl(0_0%_75%)]">·</span>
            <a
              href="https://getgreenlight.net/terms-of-service"
              className="text-sm text-[hsl(0_0%_50%)] hover:text-[hsl(0_0%_5%)] transition-colors"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
